import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import InputResourceCard from 'shared/components/InputResourceCard';

export default () => {
  const $resources = $('.resource');
  $resources.each((_, element) => {
    const $element = $(element);

    const name = $element.attr('data-name');
    const title = $element.attr('data-title');
    const value = $element.attr('data-id');
    const type = $element.attr('data-type');
    const thumbnail = $element.attr('data-thumbnail');

    ReactDOM.render(
      <InputResourceCard
        name={name}
        title={title}
        value={value}
        resourceType={type}
        thumbnail={thumbnail}
      />,
      element
    );
  });
};



// WEBPACK FOOTER //
// ./src/plugins/resources.js